<script setup lang="ts">
import login from '@/assets/login.webp'
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/shared/Footer.vue'
</script>

<template>
    <Header :dark="false" />
    <main class="grid min-h-[80dvh] md:grid-cols-2">
        <div class="relative hidden md:flex md:p-4 lg:p-6">
            <div class="relative flex-1">
                <img :src="login" alt="Image" class="pointer-events-none sticky top-2 max-h-[87dvh] w-full rounded-2xl object-cover object-bottom" />
            </div>
        </div>
        <div class="mx-auto flex w-full max-w-[464px] flex-col justify-center px-4 py-8 md:py-20">
            <slot />
        </div>
    </main>
    <Footer :dark="false" />
</template>
